/**
 * Expand/Gesehen-Zustand der `ReadyRow`-Zeilen (T8): einmal aufgeklappt
 * bleibt im Stichproben-Zähler gezählt, auch wenn die Zeile wieder zuklappt.
 */
import { useState } from 'react'

export function useReadyRowState() {
  const [openIds, setOpenIds] = useState<Set<string>>(new Set())
  const [everSeenIds, setEverSeenIds] = useState<Set<string>>(new Set())

  const toggleRow = (id: string) => {
    setOpenIds((prev) => {
      const next = new Set(prev)
      if (next.has(id)) next.delete(id)
      else next.add(id)
      return next
    })
    setEverSeenIds((prev) => new Set(prev).add(id))
  }

  return { openIds, everSeenIds, toggleRow }
}
